/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
export class PropertyChangeEvent {
    ScriptUnit:string
    Properties: Array<string>;
    Values: Array<any>;
    Timestamp: Date;

    constructor() {
        this.Timestamp = new Date();
    }
}


export class CallerInfo {
    ScriptUnit: string;
    FunctionName: string;
    Parameters: Array<any>;
}

export class MethodPropertyChangeEvent  {
    CallerInfo:CallerInfo;
    Event: PropertyChangeEvent;
    IsFinished: boolean;
    Error: any;
}